module.exports = __webpack_public_path__ + "img/missing-image_640X480.698c75c3.png";